import React from 'react';
import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

import { IEnrichedProduct } from './model/Menu';
import { MenuProductInfoModifiers } from './MenuProductInfoModifiers';

const StyledBox = styled(Box)({
    display: 'flex',
    flex: 1,
    height: 0,
    flexDirection: 'column'
});

interface MenuEnrichedProductInfoProps {
    item: IEnrichedProduct;
    handlePostAddedToBasket: () => void;
    categoryId: string;
}

export const MenuEnrichedProductInfo: React.FC<React.PropsWithChildren<MenuEnrichedProductInfoProps>> = ({
    item,
    handlePostAddedToBasket,
    categoryId
}) => (
    <StyledBox>
        <MenuProductInfoModifiers
            categoryId={categoryId}
            item={item}
            postAddedToBasket={handlePostAddedToBasket}
        />
    </StyledBox>
);
